import { render, staticRenderFns } from "./ObjectCardMemory.vue?vue&type=template&id=0b05cfe0&scoped=true&"
import script from "./ObjectCardMemory.vue?vue&type=script&lang=js&"
export * from "./ObjectCardMemory.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardMemory.vue?vue&type=style&index=0&id=0b05cfe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05cfe0",
  null
  
)

export default component.exports